
<button (click) = "CalculateLeaves(employeeList)"
    class = "m-1 btn btn-light btn-outline-dark" Button>Calculate Leaves
</button>
